import { render } from "./pb-calendar.vue?vue&type=template&id=47f000e3"
import script from "./pb-calendar.vue?vue&type=script&lang=js"
export * from "./pb-calendar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__